
import { Link } from "react-router-dom";

const Mypaymenthistroy = () => {
  return (
    <section>
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-1 text-end">
            <Link to="/">
              <h6>
                {" "}
                <i class="fa fa-home" aria-hidden="true"></i>Home
              </h6>
            </Link>
          </div>
          /
          <div className="col-lg-5">
            <h6>Payment Withdraw Request History Details</h6>
          </div>
          <div className="col-lg-10 mt-3 mb-3">
            <div className="card border-0 shadow ">
              <div className="card-header bg bg-info border-0">
                <h4>Payment Withdraw Request History Details</h4>
              </div>

              <div className="card-body">
                <div className="col-lg-12 ">
                  <div className="row text-end">
                    <div className="col-lg-6"></div>
                    <div className="col-lg-3">
                      <label for="exampleInputPassword1" class="form-label">
                        Search:
                      </label>
                    </div>

                    <div className="col-lg-3">
                      <input
                        type="password"
                        class="form-control"
                        placeholder="Sponsor ID"
                        id="exampleInputPassword1"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-lg-12 mt-3">
                  <div class="table-responsive">
                    <table class="table table-bordered  mb-0 text-nowrap">
                      <thead>
                        <tr>
                          <th> Sl.No </th>
                          <th>User ID</th>
                          <th>Name</th>
                          <th>Amount</th>
                          <th>Mobile Number </th>
                          <th>TDS Charges</th>
                          <th>Send Amount</th>
                          <th>Account No</th>
                          <th>IFSC Code</th>
                          <th>Bank</th>
                          <th>Branch</th>
                          <th>Account Photo</th>
                          <th>Date</th>
                          <th>Time</th>
                          <th>Status</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr>
                          <td>01</td>
                          <td>UI123</td>
                          <td>WDM</td>
                          <td>Rs 5000</td>

                          <td>99123456</td>
                          <td>10%</td>
                          <td>Rs 3000</td>
                          <td>UT0BH12346</td>
                          <td>IFCD1233</td>
                          <td>SBI</td>
                          <td>Bangalore</td>
                          <td>image</td>
                          <td>10/02/2022</td>
                          <td>11:20</td>

                          <td>
                            <button
                              type="button"
                              class="btn btn-sm btn-success"
                              data-toggle="modal"
                              data-target="#exampleModal"
                            >
                              Approval
                            </button>
                            <button
                              type="button"
                              class="btn btn-sm btn-danger mx-2"
                              data-toggle="modal"
                              data-target="#exampleModal"
                            >
                             Reject
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        
      </div>
    </section>
  );
};

export default Mypaymenthistroy;
